// React
import Dropzone from 'react-dropzone';
import React, { useRef, useState } from 'react';
import { Card, CardBody, Col, Input, Label, Row } from 'reactstrap';

// Components Injection
import {
  ModalDelete,
  notifyError,
  notifySuccess,
} from '../../containers/componentsInjection';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Helpers
import * as url from '../../../../helpers/url_helper';
import { APIClient } from '../../../../helpers/api_helper';

export const WhatsappTab = ({
  planId,
  plan,
  getPlanById,
  whatsappMedias,
  setWhatsappMedias,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileIdToDelete, setFileIdToDelete] = useState('');

  const api = new APIClient();

  function toggle(fileId) {
    setIsOpen(!isOpen);

    if (fileId) {
      setFileIdToDelete(fileId);
    }
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      welcomeMessage: plan ? plan.welcome_message : '',
      welcomeMedia: plan ? plan.welcome_midia_url : '',
    },
    validationSchema: Yup.object({
      welcomeMessage: Yup.string().nullable(),
      welcomeMedia: Yup.mixed().nullable(),
    }),

    onSubmit: (values) => {
      const formData = new FormData();

      formData.append('welcomeMessage', values.welcomeMessage || '');

      if (values.welcomeMedia instanceof File) {
        formData.append('welcomeMedia', values.welcomeMedia);
      }

      whatsappMedias.forEach((media, i) => {
        if (media.file instanceof File) {
          formData.append(`whatsappMedia${i + 1}`, media.file);
        }

        formData.append(`whatsappCaption${i + 1}`, media.caption || '');

        if (media.preview?.startsWith('blob:')) {
          URL.revokeObjectURL(media.preview);
        }
      });

      api
        .create(
          url.BASE + `register/plan/save-whatsapp-messages/${planId}`,
          formData
        )
        .then((response) => {
          notifySuccess(response.message || 'Enviado com sucesso!');
          getPlanById(planId);
        })
        .catch((error) => {
          notifyError('Erro ao enviar: ' + error.message);
        });
    },
  });

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };

  const handleDeleteFile = () => {
    api
      .delete(
        url.BASE +
          `register/plan/whatsapp-file/${planId}?file=${fileIdToDelete}`
      )
      .then((response) => {
        notifySuccess(response.message || 'Excluído com sucesso!');
        getPlanById(planId);
        toggle();
      })
      .catch((error) => {
        notifyError('Erro ao excluir: ' + error.message);
      });
  };

  const handleRemoveFile = (index) => {
    setWhatsappMedias((prev) => {
      const updated = [...prev];
      const removed = updated[index];
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      updated[index] = {
        ...updated[index],
        file: null,
        preview: null,
        fileName: '',
      };
      return updated;
    });
  };

  const handleAcceptedFiles = (index, file) => {
    const updated = [...whatsappMedias];
    updated[index] = {
      ...updated[index],
      file,
      preview: URL.createObjectURL(file),
      fileName: file.name,
    };
    setWhatsappMedias(updated);
  };

  return (
    <React.Fragment>
      <CardBody className="p-3">
        <Row className="g-3">
          <Col md={12}>
            <Label htmlFor="welcomeMessage" className="form-label fw-semibold">
              Mensagem de boas-vindas
            </Label>
            <Input
              rows={4}
              id="welcomeMessage"
              type="textarea"
              name="welcomeMessage"
              onBlur={validation.handleBlur}
              value={validation.values.welcomeMessage}
              onChange={validation.handleChange}
            />
          </Col>

          <Col md={12} className="mb-2">
            <Label htmlFor="welcomeMessage" className="form-label fw-semibold">
              Mídia da mensagem
            </Label>

            {validation.values.welcomeMedia ? (
              <React.Fragment>
                <div className="d-flex justify-content-start align-items-center mb-2 gap-2">
                  <span className="fw-bold mb-0">
                    Arquivo:{' '}
                    <span className="fw-normal">
                      {validation.values.welcomeMedia instanceof File
                        ? validation.values.welcomeMedia.name
                        : plan.welcome_midia_filename}
                    </span>
                  </span>

                  <div className="d-flex gap-2">
                    <button
                      hidden={!plan.welcome_midia_url}
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleDownload(plan.welcome_midia_url)}
                    >
                      <i className="ri-download-line me-1 align-middle" />
                      Download
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => {
                        if (plan.welcome_midia_id) {
                          toggle(plan.welcome_midia_id);
                        } else {
                          validation.setFieldValue('welcomeMedia', null);
                        }
                      }}
                    >
                      <i className="ri-delete-bin-line me-1 align-middle" />
                      {plan.welcome_midia_url ? 'Excluir' : 'Remover'}
                    </button>
                  </div>
                </div>

                <div>
                  {(() => {
                    const media = validation.values.welcomeMedia;
                    const isFile = media instanceof File;
                    const url = isFile
                      ? URL.createObjectURL(media)
                      : plan.welcome_midia_url;

                    const isVideo =
                      isFile && media.type.startsWith('video/')
                        ? true
                        : /\.(mp4|webm|ogg)$/i.test(url);

                    return isVideo ? (
                      <video
                        src={url}
                        controls
                        width={150}
                        height={100}
                        style={{ objectFit: 'cover', borderRadius: 4 }}
                      />
                    ) : (
                      <img
                        src={url}
                        alt="Mídia"
                        width={150}
                        height={100}
                        style={{ objectFit: 'cover', borderRadius: 4 }}
                      />
                    );
                  })()}
                </div>
              </React.Fragment>
            ) : (
              <Input
                type="file"
                id="welcomeMedia"
                name="welcomeMedia"
                className="profile-img-file-input"
                accept="image/*,video/*"
                onBlur={validation.handleBlur}
                onChange={(event) => {
                  const file = event.currentTarget.files?.[0];
                  if (file) {
                    validation.setFieldValue('welcomeMedia', file);
                  }
                }}
              />
            )}
          </Col>

          <Col md={12}>
            <div className="list-unstyled mb-0" id="file-previews">
              {whatsappMedias.map((media, index) => {
                const mimeType = media.file?.type || '';
                const fileName = media.fileName || '';

                const isImage =
                  mimeType.startsWith('image/') ||
                  ['.png', '.jpg', '.jpeg', '.gif'].some((ext) =>
                    fileName.toLowerCase().endsWith(ext)
                  );
                const isVideo =
                  mimeType.startsWith('video/') ||
                  fileName.toLowerCase().endsWith('.mp4');

                return (
                  <Card className="mt-2 mb-2 p-3 border rounded" key={index}>
                    <h5>{`Mídia #${index + 1}`}</h5>

                    <Row className="align-items-center">
                      {media.preview && (
                        <Col xs="auto" className="text-center pe-0">
                          {isImage && (
                            <img
                              height={80}
                              width={80}
                              alt={media.fileName}
                              src={media.preview}
                              style={{
                                objectFit: 'cover',
                                borderRadius: '4px',
                              }}
                            />
                          )}
                          {isVideo && (
                            <video
                              height={80}
                              width={80}
                              src={media.preview}
                              controls
                              style={{ borderRadius: '4px' }}
                            />
                          )}
                        </Col>
                      )}
                      <Col className="ps-3">
                        <Row className="justify-content-between">
                          <Col className="pb-2">
                            {media.preview ? (
                              <React.Fragment>
                                <span className="fw-bold me-2">Arquivo:</span>
                                <span>{media.fileName}</span>
                              </React.Fragment>
                            ) : (
                              <Dropzone
                                accept="image/*,video/*"
                                maxFiles={1}
                                onDrop={(acceptedFiles) => {
                                  if (acceptedFiles.length) {
                                    handleAcceptedFiles(
                                      index,
                                      acceptedFiles[0]
                                    );
                                  }
                                }}
                                onDropRejected={() =>
                                  notifyError('Apenas imagens ou vídeos')
                                }
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div className="d-flex flex-column">
                                    <Label className="form-label fw-bold">
                                      Selecione a mídia
                                    </Label>
                                    <button
                                      {...getRootProps()}
                                      type="button"
                                      className="btn btn-outline-success btn-sm"
                                      style={{ width: 'fit-content' }}
                                    >
                                      <i className="ri-add-line align-middle" />
                                      Anexar arquivo
                                    </button>
                                  </div>
                                )}
                              </Dropzone>
                            )}
                          </Col>

                          {media.preview && (
                            <Col
                              xs="auto"
                              className="d-flex gap-2 justify-content-end mb-2"
                            >
                              <button
                                hidden={media.file}
                                type="button"
                                className="btn btn-soft-primary btn-sm"
                                onClick={() => handleDownload(media.preview)}
                              >
                                <i className="ri-download-line me-1 align-middle" />
                                Download
                              </button>

                              <button
                                type="button"
                                className="btn btn-soft-danger btn-sm"
                                onClick={() => {
                                  if (media.file) {
                                    handleRemoveFile(index);
                                  } else {
                                    toggle(media.id);
                                  }
                                }}
                              >
                                <i className="ri-delete-bin-line me-1 align-middle" />
                                {media.file ? 'Remover' : 'Excluir'}
                              </button>
                            </Col>
                          )}
                        </Row>

                        <div>
                          <Label className="form-label fw-bold">{`Legenda da Mídia #${
                            index + 1
                          }`}</Label>
                          <Input
                            rows={4}
                            type="textarea"
                            placeholder="Digite a legenda"
                            value={media.caption}
                            onChange={(e) => {
                              const updated = [...whatsappMedias];
                              updated[index].caption = e.target.value;
                              setWhatsappMedias(updated);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card>
                );
              })}

              <div className="text-end pt-2">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    validation.handleSubmit();
                  }}
                >
                  Enviar
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>

      <ModalDelete
        isOpen={isOpen}
        toggle={toggle}
        goBack={toggle}
        handleDelete={handleDeleteFile}
      />
    </React.Fragment>
  );
};
